import React from 'react';
import { Box } from '@mui/material';

const SkipNavigation = () => (
  <Box
    component="a"
    href="#main-content"
    sx={{
      position: 'absolute',
      left: '-9999px',
      top: 'auto',
      width: '1px',
      height: '1px',
      overflow: 'hidden',
      zIndex: 9999,
      '&:focus': {
        position: 'fixed',
        top: 8,
        left: 8,
        width: 'auto',
        height: 'auto',
        overflow: 'visible',
        px: 3,
        py: 1.5,
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
        borderRadius: 2,
        fontSize: '0.875rem',
        fontWeight: 600,
        textDecoration: 'none',
        outline: '2px solid',
        outlineColor: 'primary.dark',
        outlineOffset: '2px',
        boxShadow: 4,
      },
    }}
  >
    Skip to main content
  </Box>
);

export default SkipNavigation;
